const csrfToken = () => {
  const meta = document.querySelector('meta[name=csrf-token]');
  const token = meta?.getAttribute('content');

  return token || false;
};

const requestHeaders = () => ({ 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() });

export { csrfToken, requestHeaders };
